import React from 'react';
import { ButtonWithIcon } from '@els/els-react--button';
import { PLACEMENT_BOTTOM, PLACEMENT_RIGHT, PLACEMENT_MODAL } from '../constants';

import './ConditionsPlacementControl.scss';

function ConditionsPlacementControl({ placement, setPlacement, setIsShown }) {
  const getDockButtonClassName = (pls) =>
    `project-route-conditions-placement-control__button project-route-conditions-placement-control__button--dock${placement === pls ? ' current' : ''}`;

  return (
    <div className="project-route-conditions-placement-control u-els-padding-top-3o4 u-els-padding-right">
      <ButtonWithIcon
        data-e2e="conditions-open-in-modal"
        type="link"
        size="small"
        linkIconSize="s"
        sprite="Modal"
        iconOnly
        onClick={() => setPlacement(PLACEMENT_MODAL)}
        className={`e2e-conditions-open-in-modal ${getDockButtonClassName(PLACEMENT_MODAL)}`}>
        Open in modal
      </ButtonWithIcon>
      <ButtonWithIcon
        data-e2e="conditions-dock-bottom"
        type="link"
        size="small"
        linkIconSize="s"
        sprite="DockBottom"
        iconOnly
        onClick={() => setPlacement(PLACEMENT_BOTTOM)}
        className={`e2e-conditions-dock-bottom ${getDockButtonClassName(PLACEMENT_BOTTOM)}`}>
        Docked bottom
      </ButtonWithIcon>
      <ButtonWithIcon
        data-e2e="conditions-dock-right"
        type="link"
        size="small"
        linkIconSize="s"
        sprite="DockRight"
        iconOnly
        onClick={() => setPlacement(PLACEMENT_RIGHT)}
        className={`e2e-conditions-dock-right ${getDockButtonClassName(PLACEMENT_RIGHT)}`}>
        Docked right
      </ButtonWithIcon>
      <span className="project-route-conditions-placement-control__divider u-els-margin-right u-els-margin-left-1o2" />
      <ButtonWithIcon
        data-e2e="conditions-close"
        type="link"
        size="small"
        linkIconSize="s"
        sprite="Close"
        iconOnly
        onClick={() => setIsShown(false)}
        className="'project-route-conditions-placement-control__button project-route-conditions-placement-control__button--close e2e-modal-close">
        Close conditions
      </ButtonWithIcon>
    </div>
  );
}

export default ConditionsPlacementControl;
